import type { FC } from 'react';
import React from 'react';

import styles from './SkeletonBar.module.scss';

export const SkeletonBar: FC = () => {
  return (
    <div className={styles.skeleton}>
      <div className={styles.avatarSkeleton} />
      <div className={styles.textSkeleton} />
    </div>
  );
};
